import React, { useEffect, useState } from 'react';
import { logger } from '@/lib/logger';
import { FloorPlanViewerV2 } from './FloorPlanViewerV2';
import { getAuthenticatedSupabaseClient } from '@/integrations/supabase/client';
import { FloorPlan } from '@/types/floorPlanViewer';

interface EnhancedFloorPlanViewerProps {
  floorPlan: FloorPlan;
  onBack?: () => void;
  viewMode?: 'design' | 'presentation';
  onViewModeChange?: (mode: 'design' | 'presentation') => void;
  onProcessComplete?: () => void;
}

interface CADMetadata {
  svg_url: string;
  dimensions: {
    width: number;
    height: number;
    units: string;
    scale: number;
  };
}

export function EnhancedFloorPlanViewer(props: EnhancedFloorPlanViewerProps) {
  const [cadMetadata, setCadMetadata] = useState<CADMetadata | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadCADMetadata();
  }, [props.floorPlan.id]);

  const loadCADMetadata = async () => {
    setIsLoading(true);
    try {
      // Check if this is a CAD file
      const supabase = await getAuthenticatedSupabaseClient();
      const { data: metadata, error } = await supabase
        .from('floor_plan_dwg_metadata')
        .select('svg_url, dimensions')
        .eq('floor_plan_id', props.floorPlan.id)
        .single();

      if (!error && metadata) {
        setCadMetadata(metadata);
      }
    } catch (error) {
      logger.error('Error loading CAD metadata:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // For now, pass through to regular viewer
  // In the next step, we'll enhance the viewer to use SVG overlay
  return (
    <FloorPlanViewerV2 
      {...props}
      // We'll add CAD-specific props here
      cadMetadata={cadMetadata}
    />
  );
}
